import { createSelector } from '@reduxjs/toolkit';

import { advancementTabNames } from '@shared/constants';
import { advancementHistoryModuleSel } from '@shared/duck/selectors/advancementHistory.selectors';
import {
  advancementModuleSel,
  allNotAwardedAdvancementsCountSel,
  isCouncilOrgActiveSel,
  notAwardedAdvancementsCountSel,
  organizationGuidSel,
  packRosterItemsSel,
  packRosterLoadingSel,
  packRosterModuleSel,
  parentOrgGuidSel,
} from '@shared/duck/selectors/general.selectors';

import { reportsSel } from '../../reports/basicReports/duck/selectors';
import {
  advancementReportModuleName,
  advancementUploadModuleName,
  pendingItemsModuleName,
  purchaseOrdersModuleName,
} from './constants';

export {
  advancementModuleSel,
  advancementHistoryModuleSel,
  packRosterModuleSel,
  packRosterLoadingSel,
  packRosterItemsSel,
  notAwardedAdvancementsCountSel,
  allNotAwardedAdvancementsCountSel,
};

export const isValidOrganizationSel = state => {
  const isCouncil = isCouncilOrgActiveSel(state);
  if (isCouncil) {
    return parentOrgGuidSel(state) !== organizationGuidSel(state);
  }

  return true;
};

export const advancementReportModuleSel = state =>
  advancementModuleSel(state)[advancementReportModuleName];

export const advancementUploadModuleSel = state =>
  advancementModuleSel(state)[advancementUploadModuleName];

export const activeTabSel = state => advancementModuleSel(state).activeTab;
export const unitRosterReportLoadingSel = state =>
  advancementModuleSel(state).unitRosterReportLoading;

export const pendingItemsModuleSel = state =>
  advancementModuleSel(state)[pendingItemsModuleName];

export const purchaseOrdersModuleSel = state =>
  advancementModuleSel(state)[purchaseOrdersModuleName];

export const youthItemsSel = createSelector(packRosterItemsSel, items =>
  items.filter(item => !item.isAdult),
);
export const adultItemsSel = createSelector(packRosterItemsSel, items =>
  items.filter(item => item.isAdult),
);

export const leaderItemsSel = createSelector(packRosterItemsSel, items =>
  items.filter(item => item.isLeader),
);

export const selectedKeysSel = state => packRosterModuleSel(state).selectedKeys;
export const selectedItemsSel = createSelector(
  packRosterItemsSel,
  selectedKeysSel,
  (items, selectedKeys) => {
    const formattedSelectedKeys = selectedKeys.map(key =>
      typeof key === 'string' ? Number(key.split('*')[0]) : key,
    );
    const filtered = items.filter(({ userId }) =>
      formattedSelectedKeys.includes(userId),
    );
    return filtered;
  },
);

export const isMissingSomeMemberIdSel = createSelector(
  selectedItemsSel,
  selectedItems => selectedItems.some(item => !item.memberId),
);

export const reportsSelectedItemsSel = createSelector(
  selectedItemsSel,
  activeTabSel,
  (selectedItems, activeTab) =>
    activeTab === advancementTabNames.ROSTER ? selectedItems : [],
);

export const advancementHistoryLoadingSel = state =>
  advancementHistoryModuleSel(state).loading;

export const selectedYouthSel = createSelector(
  selectedItemsSel,
  selectedItems => selectedItems.filter(({ isAdult }) => !isAdult),
);
export const selectedUnitReportCodeSel = state =>
  advancementModuleSel(state).selectedUnitReportCode;
export const selectedUnitReportSel = createSelector(
  selectedUnitReportCodeSel,
  reportsSel,
  (selectedReportCode, reports) =>
    reports.find(({ reportCode }) => reportCode == selectedReportCode) || {},
);
